import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Fetches the dumpster folder for archive mailbox folder tree and
 * adds mapping to session store.
 */

export interface FETCH_ARCHIVE_DUMPSTER_FOLDERActionMessage {
    mailboxInfo: MailboxInfo;
}
export const fetchArchiveDumpsterFolder: (
    mailboxInfo: MailboxInfo
) => FETCH_ARCHIVE_DUMPSTER_FOLDERActionMessage = action(
    'FETCH_ARCHIVE_DUMPSTER_FOLDER',
    (mailboxInfo: MailboxInfo): FETCH_ARCHIVE_DUMPSTER_FOLDERActionMessage => ({
        mailboxInfo,
    })
);
